import React, {Fragment} from "react";
import PropTypes from "prop-types";
import Page from "../../../../../components/BaseComponents/Page/Page";
import {FaSolidIcon} from "../../../../../components/FontAwesomeIcons";
import {TabViewItem} from "../../../../../components/BaseComponents/TabView";
import TimeoffRequestsPermessiTab from "./TimeoffRequestsPermessiTab";
import TimeoffRequestsFerieTab from "./TimeoffRequestsFerieTab";
import TimeoffRequestsBustePagaTab from "./TimeoffRequestsBustePagaTab";
import TimeoffRequestsFilesTab from "./TimeoffRequestsFilesTab";
import ExpensesTab from "./ExpensesTab";
import AwayTripsTab from "./AwayTripsTab";
import ClockingSessionsView from "./ClockingSessionsView";
import TaskDashboardTab from "./TaskDashboardTab";
import FuxHTTP from "../../../../../lib/FuxFramework/FuxHTTP";
import APIConfig from "../../../../../api/APIConfig";
import AuthAPI from "../../../../../api/AuthAPI";

const TAB_PERMESSI = "permessi";
const TAB_FERIE = "ferie";
const TAB_BUSTE_PAGA = "buste_paga";
const TAB_FILES = "files";
const TAB_TASKS = "tasks";
const TAB_EXPENSES = "expenses";
const TAB_AWAY_TRIPS = "away_trips";

export default class SelfCareDipendenteModal extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            activeTab: TAB_PERMESSI,
            taskCount: 0,
            taskTabMounted: false
        };
        this.activeTabColor = "#293069";
    }

    componentDidMount() {
        this.loadTaskCount();
    }

    requestTaskCount = idDipendente => {
        return FuxHTTP.apiGetRequestWithPromise(
            APIConfig.url("/modulo-task/tasks/get-count"),
            {
                token: AuthAPI.getUserAccessToken(),
                id_dipendente: idDipendente
            },
            FuxHTTP.RESOLVE_DATA,
            FuxHTTP.REJECT_MESSAGE
        );
    }

    sumTaskCounts = responses => {
        const countedStaffIds = {};
        let adminTasksCounted = false;
        let total = 0;

        responses.forEach(response => {
            (response || []).forEach(item => {
                const count = parseInt(item.num_task, 10) || 0;
                if (item.id_dipendente === null || item.id_dipendente === undefined) {
                    if (!adminTasksCounted) {
                        total += count;
                        adminTasksCounted = true;
                    }
                    return;
                }

                const staffId = String(item.id_dipendente);
                if (!countedStaffIds[staffId]) {
                    total += count;
                    countedStaffIds[staffId] = true;
                }
            });
        });

        return total;
    }

    loadTaskCount = _ => {
        const staffIds = (this.props.staffList || [])
            .map(staff => staff.id_dipendente)
            .filter(Boolean);
        const requests = staffIds.length > 1
            ? staffIds.map(this.requestTaskCount)
            : [this.requestTaskCount(null)];

        Promise.all(requests)
            .then(responses => this.setState({taskCount: this.sumTaskCounts(responses)}))
            .catch(_ => this.setState({taskCount: 0}));
    }

    handleTabChange = tab => _ => this.setState({
        activeTab: tab,
        taskTabMounted: this.state.taskTabMounted || tab === TAB_TASKS
    });

    render() {
        return (
            <Fragment>
                <Page
                    title={"Area dipendente"}
                    leftIcon={<FaSolidIcon name={"chevron-left"}/>}
                    onLeftIconClick={this.props.onDismiss}
                    active={this.props.active}
                    noPadding={true}
                    content={
                        <div className={"d-flex flex-column h-100"}>
                            <div className={"d-flex bg-white sticky-top shadow-sm border-top"}>
                                <TabViewItem
                                    onClick={this.handleTabChange(TAB_PERMESSI)}
                                    className={"py-2 text-muted d-flex align-items-center justify-content-center flex-fill " + (this.state.activeTab === TAB_PERMESSI ? " active" : "")}
                                    activeColor={this.activeTabColor}
                                >
                                    Permessi
                                </TabViewItem>
                                <TabViewItem
                                    onClick={this.handleTabChange(TAB_FERIE)}
                                    className={"py-2 text-muted d-flex align-items-center justify-content-center flex-fill " + (this.state.activeTab === TAB_FERIE ? " active" : "")}
                                    activeColor={this.activeTabColor}
                                >
                                    Ferie
                                </TabViewItem>
                                <TabViewItem
                                    onClick={this.handleTabChange(TAB_BUSTE_PAGA)}
                                    className={"py-2 text-muted d-flex align-items-center justify-content-center flex-fill " + (this.state.activeTab === TAB_BUSTE_PAGA ? " active" : "")}
                                    activeColor={this.activeTabColor}
                                >
                                    Paghe
                                </TabViewItem>
                                <TabViewItem
                                    onClick={this.handleTabChange(TAB_TASKS)}
                                    className={"py-2 text-muted d-flex align-items-center justify-content-center flex-fill " + (this.state.activeTab === TAB_TASKS ? " active" : "")}
                                    activeColor={this.activeTabColor}
                                >
                                    Task
                                    {
                                        this.state.taskCount > 0 &&
                                        <span className={"badge badge-pill badge-danger ml-1"}>
                                            {this.state.taskCount}
                                        </span>
                                    }
                                </TabViewItem>
                                <TabViewItem
                                    onClick={this.handleTabChange(TAB_FILES)}
                                    className={"py-2 text-muted d-flex align-items-center justify-content-center flex-fill " + (this.state.activeTab === TAB_FILES ? " active" : "")}
                                    activeColor={this.activeTabColor}
                                >
                                    File
                                </TabViewItem>
                                <TabViewItem
                                    onClick={this.handleTabChange(TAB_EXPENSES)}
                                    className={"py-2 text-muted d-flex align-items-center justify-content-center flex-fill " + (this.state.activeTab === TAB_EXPENSES ? " active" : "")}
                                    activeColor={this.activeTabColor}
                                >
                                    Spese
                                </TabViewItem>
                                <TabViewItem
                                    onClick={this.handleTabChange(TAB_AWAY_TRIPS)}
                                    className={"py-2 text-muted d-flex align-items-center justify-content-center flex-fill " + (this.state.activeTab === TAB_AWAY_TRIPS ? " active" : "")}
                                    activeColor={this.activeTabColor}
                                >
                                    Trasferte
                                </TabViewItem>
                            </div>

                            {
                                this.state.activeTab === TAB_PERMESSI &&
                                <TimeoffRequestsPermessiTab
                                    staffList={this.props.staffList}
                                />
                            }
                            {
                                this.state.activeTab === TAB_FERIE &&
                                <TimeoffRequestsFerieTab
                                    staffList={this.props.staffList}
                                />
                            }
                            {
                                this.state.activeTab === TAB_BUSTE_PAGA &&
                                <TimeoffRequestsBustePagaTab
                                    staffList={this.props.staffList}
                                />
                            }
                            {
                                this.state.taskTabMounted &&
                                <TaskDashboardTab active={this.state.activeTab === TAB_TASKS}/>
                            }
                            {
                                this.state.activeTab === TAB_FILES &&
                                <TimeoffRequestsFilesTab
                                    staffList={this.props.staffList}
                                />
                            }
                            {
                                this.state.activeTab === TAB_EXPENSES &&
                                <ExpensesTab
                                    staffList={this.props.staffList}
                                />
                            }
                            {
                                this.state.activeTab === TAB_AWAY_TRIPS &&
                                <AwayTripsTab
                                    staffList={this.props.staffList}
                                />
                            }
                        </div>
                    }
                />
            </Fragment>
        );
    }
}

SelfCareDipendenteModal.propTypes = {
    active: PropTypes.bool,
    onDismiss: PropTypes.func,
    staffList: PropTypes.array
};
